import { useState, useContext } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import Employee from '../../../services/Employee';
import { toast } from 'react-toastify';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import LoaderSpinner from '../../Core/LoaderSpinner';

const PayRatesUpdateDescriptionForm = ({
  employeeId,
  dataSelected,
  afterSave,
}: {
  employeeId: string;
  dataSelected: any;
  afterSave: () => void;
}) => {
  const { token }: any = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = new FormData(e.target as HTMLFormElement);
      const body = {} as any;
      for (const [key, value] of data.entries()) {
        (body as any)[key] = value;
      }
      await Employee(token).updatePayRateDescription(employeeId, dataSelected?.id, body);
      toast.success('Update success');
      afterSave();
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Invalid Request');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Row>
        <Col style={{ minHeight: '100px' }}>
          <LoaderSpinner />
        </Col>
      </Row>
    );
  }

  return (
    <>
      {!loading && (
        <form onSubmit={handleSubmit}>
          <Row>
            <Col
              xs="12"
              style={{ maxHeight: '350px', overflowY: 'scroll' }}
              dangerouslySetInnerHTML={{
                __html: (() => {
                  const items = Array.isArray(dataSelected?.description) ? dataSelected.description : [];
                  if (!items.length) {
                    return '<p class="p-0 m-0 text-muted">No description yet</p>';
                  }
                  const texts = items
                    .map((d: any) => (d?.text ? d.text : ''))
                    .filter((value: string) => value.length)
                    .join('</p><p class="p-0 m-0">');
                  return texts
                    ? '<p class="p-0 m-0">' + texts + '</p>'
                    : '<p class="p-0 m-0 text-muted">No description yet</p>';
                })(),
              }}
            />
          </Row>
          <hr />
          <Row>
            <Col xs="12">
              <FormGroup className="form-control-label">
                <Label>Add Description</Label>
                <Input type="textarea" name="description" required />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="text-right">
              <Button className="btn-danger" type="button" onClick={() => afterSave()}>
                Close
              </Button>
              <Button className="btn-success" type="submit">
                Save
              </Button>
            </Col>
          </Row>
        </form>
      )}
    </>
  );
};

export default PayRatesUpdateDescriptionForm;
